// ============================================================================
// selfDiscovery.js — shared between SelfDiscoveryGate, Login.jsx, and
// SelfDiscoveryContinue. A self-discovery link stashes its decoded token
// here BEFORE the login form is shown; Login.jsx checks for it right after
// a successful sign-in to decide where to send the user next.
// ============================================================================

export const SD_PENDING_KEY = "sd_pending_link";

/** Call this right after a successful login (password or Google). */
export const getPostLoginRedirect = () => {
  return sessionStorage.getItem(SD_PENDING_KEY)
    ? "/self-discovery/continue"
    : "/dashboard";
};
